import Img1 from './images/1.jpg';
import Img2 from './images/2.jpg';
import Img3 from './images/3.jpg';
import Img4 from './images/4.jpg';

export const PLASTICS = [
    {
        name: 'PVC',
        value: 4.438
    },
    {
        name: 'PP',
        value: 4.268
    },
    {
        name: 'PET',
        value: 5.298
    },
    {
        name: 'HDPE',
        value: 4.478
    },
    {
        name: 'LDPE',
        value: 4.528
    },
    {
        name: 'PS',
        value: 5.608
    },
    {
        name: 'unknown',
        value: 4.770
    },
];

export const ALTERNATIVES = [
    {
        name: 'PLA',
        value: 2.703
    },
    {
        name: 'paper',
        value: 3.94
    },
    {
        name: 'wood',
        value: 3.25
    },
    {
        name: 'other_compostables',
        value: 3.058
    },
    {
        name: 'product_eliminatione',
        value: 0
    }
];

export const SAVING_IMAGES = [
    Img1,
    Img1,
    Img2,
    Img3,
    Img4
];